




import {AGENDA_ITEMS, DISCUSS} from './constants'

const interruptingChickenPhases = new Set([AGENDA_ITEMS, DISCUSS])

const isInterruptingChickenPhase = (phaseType) => {
  return interruptingChickenPhases.has(phaseType)
}

export default isInterruptingChickenPhase
